(function(){
  if(!/^\/apps\/17TRACK\/?$/i.test(window.location.pathname)) return;

  var exact={
    '查询您的订单':'Track Your Order',
    '订单编号':'Order Number',
    '订单号':'Order Number',
    '物流单号':'Tracking Number',
    '运单号':'Tracking Number',
    '邮箱':'Email',
    '电子邮件':'Email',
    '请输入订单编号':'Enter your order number',
    '请输入订单号':'Enter your order number',
    '请输入物流单号':'Enter your tracking number',
    '请输入运单号':'Enter your tracking number',
    '请输入邮箱':'Enter your email',
    '暂无物流信息':'No tracking information is available yet.',
    '未查询到订单':'We could not find this order.',
    '订单不存在':'We could not find this order.',
    '查询失败':'Tracking lookup failed. Please try again.',
    '查询中':'Tracking…'
  };

  function normalized(value){return String(value||'').replace(/\s+/g,'').trim()}
  function replacement(value){
    var clean=String(value||'').trim();
    if(exact[clean]) return exact[clean];
    var compact=normalized(clean);
    if(compact==='查询') return 'Track Order';
    return '';
  }
  function translateAttribute(el,name){
    var value=el.getAttribute(name),next=replacement(value);
    if(next) el.setAttribute(name,next);
  }
  function translate(root){
    root=root||document;
    var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    var nodes=[],node;
    while((node=walker.nextNode())) nodes.push(node);
    nodes.forEach(function(textNode){
      var parent=textNode.parentElement;
      if(!parent||/^(SCRIPT|STYLE|NOSCRIPT)$/i.test(parent.tagName)) return;
      var next=replacement(textNode.nodeValue);
      if(next) textNode.nodeValue=textNode.nodeValue.replace(textNode.nodeValue.trim(),next);
    });
    root.querySelectorAll&&root.querySelectorAll('input,button,[placeholder],[aria-label],[title]').forEach(function(el){
      ['placeholder','aria-label','title','value'].forEach(function(name){translateAttribute(el,name)});
    });
    document.documentElement.lang='en';
  }

  function run(){translate(document)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();

  var observer=new MutationObserver(function(records){
    records.forEach(function(record){
      if(record.type==='characterData'&&record.target.parentElement) translate(record.target.parentElement);
      record.addedNodes.forEach(function(added){
        if(added.nodeType===1) translate(added);
        else if(added.nodeType===3&&added.parentElement) translate(added.parentElement);
      });
    });
  });
  observer.observe(document.documentElement,{subtree:true,childList:true,characterData:true});
  [250,800,1600,3000].forEach(function(ms){setTimeout(run,ms)});
})();
